
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configurationDeleteFolderCancel: {
    id: "ConfigurationDeleteFolder.cancel",
    defaultMessage: "Cancel",
  }, 
  configurationDeleteFolderHeading: {
    id: "ConfigurationDeleteFolder.heading",
    defaultMessage: "Delete Folder",
  },
  configurationDeleteFolderNestedHeading: {
    id: "ConfigurationDeleteNestedFolder.heading",
    defaultMessage: "Delete Construction Phase",
  },
  configurationDeleteFolderNote: {
    id: "ConfigurationDeleteFolder.note",
    defaultMessage: "Note:",
  },
  configurationDeleteFolderNestedBody: {
    id: "ConfigurationDeleteNestedFolder.body",
    defaultMessage: "If you delete this construction phase, the configurations it contains will still remain, they will simply be moved to the folder storage.",
  },
  configurationDeleteFolderBody: {
    id: "ConfigurationDeleteFolder.body",
    defaultMessage: "If you delete this folder, the configurations it contains will still remain, they will simply be moved to the dashboard.",
  },
  configurationDeleteFolderConfirm: {
    id: "ConfigurationDeleteFolder.confirm",
    defaultMessage: "Confirm",
  }
});

export default MESSAGES;